var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCustomHabitIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1998 3.0632L17.0128 0.900119C16.8878 0.775804 16.7129 0.701214 16.5129 0.726077C16.3254 0.738509 16.163 0.837961 16.0505 0.987139L7.72721 12.7225L3.8905 9.54002C3.64055 9.32868 3.27813 9.35355 3.05318 9.57732L0.878623 11.7404C0.753649 11.8647 0.691162 12.0263 0.691162 12.2004C0.691162 12.3744 0.766147 12.536 0.903618 12.6479L7.43977 18.4286C7.55225 18.528 7.70222 18.5902 7.85219 18.5902C7.87718 18.5902 7.88968 18.5902 7.91467 18.5902C8.08964 18.5777 8.2521 18.4783 8.35208 18.3415L19.2498 3.89611C19.4373 3.64748 19.4123 3.2994 19.1873 3.08806L19.1998 3.0632Z",
    fill: "url(#paint0_linear_47_346)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_346",
    x1: 22.1617,
    y1: -2,
    x2: 10.0331,
    y2: 18.5902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCustomHabitIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Custom_Habit_Icon.bd3c1c06.svg";
export { ForwardRef as ReactComponent };